(function () {
  var HEADER_HEIGHT = 120;

  function scrollToAnchor(id) {
    // idと一致する要素を探し、なければ何もしない
    var target = document.getElementById(id);
    if (target) {
      var elementTop = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementTop - HEADER_HEIGHT,
        behavior: 'smooth'
      });
    }
  }

  // ページ内リンククリック時
  document.addEventListener('click', function(event) {
    var anchor = event.target.closest('a[href^="#"],a[href^="/#"]');
    if (anchor) {
      let href = anchor.getAttribute('href');
      let id = null;
      if (href.startsWith('#')) {
        id = href.substring(1);
      } else if (href.startsWith('/#')) {
        id = href.substring(2);
      }
      if (id && document.getElementById(id)) {
        event.preventDefault();
        history.replaceState(null, "", href);
        scrollToAnchor(id);
      }
    }
  });

  // ページ読み込み時
  window.addEventListener('load', function() {
    setTimeout(function(){
      let hash = location.hash; // "#new"
      if (hash) {
        let id = hash.replace('#', '');
        if (id && document.getElementById(id)) {
          scrollToAnchor(id);
        }
      }
    }, 10);
  });
})();
